$.noConflict();
jQuery(document).ready(function($){
  var width = $(window).width();
  $('.site-header__search').click(function(e){
    e.preventDefault();
    $('#SearchDrawer').slideDown();
  });
  $('.search-bar__close').click(function(e){
    e.preventDefault();
    $('#SearchDrawer').slideUp();
  });
  $('.mob_menu').click(function(e){
    e.preventDefault();
    $(this).toggleClass('change');
    $('.mobile-nav-wrapper').slideToggle();
  });
  $('.mobile-nav__icon_down').click(function(e){
    e.preventDefault();
    $(this).siblings('.mobile-nav__dropdown').slideToggle();
  });
  $('.mob_btn').click(function(e){
    e.preventDefault();
    $(this).toggleClass('open');
    $('.mobile-nav-wrapper').toggleClass('open');
  });
  $('.mob_close_icon svg').click(function(e){
    e.preventDefault();
    $('.mob_btn').toggleClass('open');
    $('.mobile-nav-wrapper').toggleClass('open');
  });
  $('.site-header__cart.ajax_cart').click(function(e){
    e.preventDefault();
    $('#topCartContent').toggleClass('visible');
    $('.cart_overlay').toggle();
  });
  $('.cart_overlay, .cart_close .icon-close').click(function(e){
    e.preventDefault();
    $('#topCartContent').toggleClass('visible');
    $('.cart_overlay').toggle();
  });
  $('.color_option_wrap .swatch').click(function(e){
    e.preventDefault();
    var variantimage = $(this).find('.color_option').attr('data-image');
    var variantid = $(this).find('.color_option').attr('data-id');
    $(this).parents('.color_option_wrap ').siblings('a').find('.var_id').val(variantid);
    $(this).parents('.color_option_wrap ').siblings('a').find('.grid-view-item__image').attr('src',variantimage);
  });
  $(".main_galery").bxSlider({
    infiniteLoop:true,
    auto: false,
    pagerCustom: '#thumb_image',
    adaptiveHeight: true
  });
  $(".quotes_single").bxSlider({
    infiniteLoop:true,
    adaptiveHeight: true,
    controls: false
  });
  
  var logoslider, maxSlides, 
      product_slider, productMaxSlides ,
      thumb_vartical_slider, thumbVertical, thumbmode, thumbWidth, thumbmargin,
      thumb_hor_slider, thumbSlider, thumbhorizontal,
      quotes_multi_slider, quote_slide, quote_width;
  if  (width < 749) {
    maxSlides = 1;
    productMaxSlides = 1;
    thumbhorizontal = 2;
    thumbVertical = 2;
    quote_slide = 1;
    thumbWidth = 100,
      thumbmargin = 10,
      thumbmode = 'horizontal';
    quote_width = 290;
  } else if  (width < 979) {
    maxSlides = 2;
    productMaxSlides = 3;
    thumbhorizontal = 2;
    thumbVertical = 3;
    quote_slide = 2;
    thumbWidth = 70,
      thumbmargin = 0,
      thumbmode = 'vertical';
    quote_width = 300;
  } else if  (width < 1129) {
    maxSlides = 4;
    productMaxSlides = 3;
    thumbhorizontal = 3;
    thumbVertical = 3;
    quote_slide = 3;
    thumbWidth = 70,
      thumbmargin = 0,
      thumbmode = 'vertical';
    quote_width = 300;
  } else  {
    maxSlides = 5;
    productMaxSlides = 4;
    thumbhorizontal = 3;
    thumbVertical = 3;
    quote_slide = 3;
    thumbWidth = 70,
      thumbmargin = 0,
      thumbmode = 'vertical';
    quote_width = 350;
  } 
  logoslider = $('.logo_slider').bxSlider({
    minSlides: 1,
    maxSlides: maxSlides,
    slideWidth: 225,
    slideMargin: 20,
    pager : false
  });
  quotes_multi_slider = $('.quotes_multi').bxSlider({
    minSlides: quote_slide,
    maxSlides: quote_slide,
    slideWidth: quote_width,
    slideMargin: 20,
    pager : false
  });
  product_slider = $('.product_slider').bxSlider({
    minSlides: 1,
    maxSlides: productMaxSlides,
    slideWidth: 270,
    slideMargin: 30,
    pager : false
  });

  thumb_vartical_slider = $('.thumb_slider.vertical').bxSlider({
    minSlides: thumbVertical,
    maxSlides: thumbVertical,
    slideWidth: thumbWidth,
    slideMargin: thumbmargin,
    mode: thumbmode,
    pager : false,
    moveSlides:1
  });

  thumb_hor_slider = $('.thumb_slider.horizontal').bxSlider({
    minSlides: thumbhorizontal,
    maxSlides: thumbhorizontal,
    slideWidth: thumbWidth,
    slideMargin: thumbmargin,
    pager : false
  });

  var $videoSrc;  
  $('.video-btn').click(function() {
    $videoSrc = $(this).data( "src" );
  });

  // when the modal is opened autoplay it  
  $('#video-modal').on('shown.bs.modal', function (e) {

    // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
    $("#video-modal #video").attr('src',$videoSrc + "?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" ); 
  })
  // stop playing the youtube video when I close the modal
  $('#video-modal').on('hide.bs.modal', function (e) {
    // a poor man's stop video
    $("#video-modal #video").attr('src',$videoSrc); 
  }) 
  $(window).resize(function() {
    var resizeWidth = $(window).width();
    if (resizeWidth < 1024) {
      $('.page-container').css('transform','translate3d(0px, 0, 0px)');  	
      $('.mobile-nav-wrapper').removeClass('js-menu--is-open');
      $('.site-header__icons-wrapper .site-header__menu').removeClass('mobile-nav--close');
      $('.site-header__icons-wrapper .site-header__menu').addClass('mobile-nav--open');
    }
    if  (resizeWidth < 749) {
      maxSlides = 1;
      productMaxSlides = 1;
      thumbhorizontal = 2;
      thumbVertical = 2;
      quote_slide = 1;
      thumbWidth = 100,
        thumbmargin = 10,
        quote_width = 290;
        thumbmode = 'horizontal';
    } else if  (resizeWidth < 979) {
      maxSlides = 2;
      productMaxSlides = 3;
      thumbhorizontal = 2;
      thumbVertical = 3;
      quote_slide = 2;
      thumbWidth = 70,
        thumbmargin = 0,
        quote_width = 300;
        thumbmode = 'vertical';
    } else if  (resizeWidth < 1129) {
      maxSlides = 4;
      productMaxSlides = 3;
      thumbhorizontal = 3;
      thumbVertical = 3;
      quote_slide = 3;
      thumbWidth = 70,
        thumbmargin = 0,
        quote_width = 300;
        thumbmode = 'vertical';
    } else  {
      maxSlides = 5;
      productMaxSlides = 4;
      thumbhorizontal = 3;
      thumbVertical = 3;
      quote_slide = 3;
      thumbWidth = 70,
        thumbmargin = 0,
        quote_width = 350;
        thumbmode = 'vertical';
    }

    if($('.product_slider').length){
      product_slider.reloadSlider({
        minSlides: 1,
        maxSlides: productMaxSlides,
        slideWidth: 280,
        slideMargin: 30,
        pager : false
      });
    }

    if($('.thumb_slider.vertical').length){
      thumb_vartical_slider.reloadSlider({
        minSlides: thumbVertical,
        maxSlides: thumbVertical,
        slideWidth: thumbWidth,
        slideMargin: thumbmargin,
        mode: thumbmode,
        pager : false,
        moveSlides:1
      });
    }
    
    if($('.quotes_multi').length){
      quotes_multi_slider.reloadSlider({
        minSlides: quote_slide,
        maxSlides: quote_slide,
        slideWidth: quote_width,
        slideMargin: 20,
        pager : false
      });
    }
  });
});